import { Box, Typography, Flex, ConditionalLink } from 'components';
import styled from 'styled-components';

const AuthButton = styled(ConditionalLink)`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  padding: 15px 0;
  border: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: ${({ theme }) => theme.colors.primary_400};
  color: ${({ theme }) => theme.colors.primary_contrast};
  cursor: pointer;
  text-transform: uppercase;
  ${({ theme }) => theme.fontTypes.type3}
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  outline: none;

  &:hover {
    background: ${({ theme }) => theme.colors.primary_200};
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary_200};
  }
`;

const LoginBoxXP = () => {
  return (
    <>
      <Flex flexDirection="column" flexGrow={0} flex={1}>
        <Flex
          flexDirection="column"
          bg="authBoxBackground"
          borderTopLeftRadius={4}
          borderTopRightRadius={4}
          px={{ m: 30, d: 45 }}
          pb={{ m: 90, d: 90 }}
          pt={{ m: 30, d: 45 }}
        >
          <Typography as="h1" type="type6" color="authLabelColor" fontWeight="bold" upper>
            Login para <br />
            assessor XP
          </Typography>

          <Box mt={3}>
            <Typography lineHeight="1.2" type="type2" color="gray_500">
              O login de assessor a UXP é exclusivamente via HUB
            </Typography>
          </Box>
          <Flex flexDirection="column" mt={{ m: 20, d: 30 }}>
            <Typography lineHeight="1.2" type="type2" color="gray_500" mb={4}>
              Clique no botão abaixo e siga o passo a passo para realizar seu login:
            </Typography>
            <Flex flexGrow={0} alignItems="center" mb={2}>
              <Typography lineHeight="1.2" type="type2" color="gray_500">
                1. Clique no botão "{' '}
                <Typography lineHeight="1.2" type="type2" color="authLabelColor" fontWeight="bold">
                  Entrar pelo HUB XP
                </Typography>
                "
              </Typography>
            </Flex>
            <Flex flexGrow={0} alignItems="center" mb={2}>
              <Typography lineHeight="1.2" type="type2" color="gray_500">
                2. Realiza seu{' '}
                <Typography lineHeight="1.2" type="type2" color="authLabelColor" fontWeight="bold">
                  acesso no HUB
                </Typography>
                ;
              </Typography>
            </Flex>
            <Flex flexGrow={0} alignItems="center" mb={2}>
              <Typography lineHeight="1.2" type="type2" color="gray_500">
                3. Clique na aba "{' '}
                <Typography lineHeight="1.2" type="type2" color="authLabelColor" fontWeight="bold">
                  conteúdos
                </Typography>
                ";
              </Typography>
            </Flex>
            <Flex flexGrow={0} alignItems="center" mb={2}>
              <Typography lineHeight="1.2" type="type2" color="gray_500">
                4. Selecione{' '}
                <Typography lineHeight="1.2" type="type2" color="authLabelColor" fontWeight="bold">
                  Universidade XP
                </Typography>
                .
              </Typography>
            </Flex>
          </Flex>
        </Flex>

        <Flex flexGrow={0}>
          <AuthButton data-testid="auth-login-submit" to="https://hub.xpi.com.br/" type="external">
            Entrar pelo HUB XP
          </AuthButton>
        </Flex>
      </Flex>
    </>
  );
};

export default LoginBoxXP;
